import { defineComponent as _defineComponent } from 'vue'
import BKButton from '@/components/AppShared/BKButton.vue'
import { mdiEye, mdiEyeOff } from '@mdi/js'
import { createUserWithEmailAndPassword, getAuth, GoogleAuthProvider, signInWithPopup, AuthError } from 'firebase/auth'
import useValidationRules from '@/shared/composables/validation'
import { nextTick, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'StartFormSignup',
  emits: ["signup"],
  setup(__props, { emit }: { emit: ({
  (e: 'signup'): void
}), expose: any, slots: any, attrs: any }) {


const rules = useValidationRules()
const loading = ref(false)
const loadingGoogleBtn = ref(false)
const showPassword = ref(false)
const email = ref<string>()
const pass = ref<string>()
const confirmPass = ref<string>()
const error = ref<string>()
const valid = ref(true)
const btnDisabled = ref(false)
const signupConfirmPassRef = ref<HTMLInputElement | null>(null)
const signupPassRef = ref<HTMLInputElement | null>(null)
const auth = getAuth()

function handleFirebaseAuthErrors(e: AuthError) {
  switch (e.code) {
    case 'auth/too-many-requests':
      error.value = 'Too many attempts to log in with this email, try again later'
      break
    case 'auth/user-not-found':
    case 'auth/wrong-password':
      error.value = 'Incorrect email or password'
      break
    case 'auth/email-already-in-use':
      error.value = 'This email is already in use. Please use another email or log in.'
      break
    default:
      error.value = e.message
      break
  }
}

async function signupPasAndMail() {
  if (!auth || !email.value || !pass.value) return
  try {
    loading.value = true
    if (pass.value !== confirmPass.value) throw new Error('Passwords must be equal')
    await createUserWithEmailAndPassword(auth, email.value, pass.value)
    if (!auth.currentUser) throw new Error('User not found')
    error.value = undefined
    emit('signup')
  } catch (errorMessage) {
    if ('code' in (errorMessage as AuthError)) {
      handleFirebaseAuthErrors(errorMessage as AuthError)
    } else if (typeof errorMessage === 'string') {
      error.value = errorMessage
    } else if (errorMessage instanceof Error) {
      error.value = errorMessage.message
    }
  } finally {
    loading.value = false
  }
}

async function userLoginGoogle() {
  loadingGoogleBtn.value = true
  try {
    const provider = new GoogleAuthProvider()
    await signInWithPopup(auth, provider)
  } catch (errorMessage) {
    if (errorMessage instanceof Error) {
      error.value = errorMessage.message
    }
  } finally {
    loadingGoogleBtn.value = false
  }
}

watch(valid, (value) => {
  btnDisabled.value = !value
})

return { __sfc: true,emit, rules, loading, loadingGoogleBtn, showPassword, email, pass, confirmPass, error, valid, btnDisabled, signupConfirmPassRef, signupPassRef, auth, handleFirebaseAuthErrors, signupPasAndMail, userLoginGoogle, BKButton, mdiEye, mdiEyeOff, nextTick }
}

})